import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class OnBoardingStepsCounter extends Vue {
  @Prop({ default: () => [] }) steps;
  @Prop({ default: 0 }) currentStep;

  get getPercentage() {
    let response = 0;
    if (this.currentStep.step === 1) {
      response = 0;
    } else if (this.currentStep.step === this.steps.length) {
      response = 100;
    } else {
      const piece = 100 / (this.steps.length - 1);
      response = piece * (this.currentStep.step - 1);
    }
    return response;
  }

  isStepCompleted(step) {
    return step.step <= this.currentStep.step;
  }

  isCurrentStep(step) {
    return step.step === this.currentStep.step;
  }

  setCurrentStep(step) {
    // if (step.step < this.currentStep.step) this.$emit("set-current-step", step);
    this.$emit("set-current-step", step);
  }
}
